import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import Img from '../../components/Img';
import Context, { contextPropType } from '../../context';
import { withContext } from '../../../Utils';
import FilerrShape from '../../../Previewer/PropsShape/FilerrShape';

import '../index.scss';

class Image extends PureComponent {

    constructor(props) {
        super(props);

        // Bindings
        this.throttledUpdateScrollStatus = throttle(this.updateScrollStatus.bind(this), 250);
        this.handleDimensions = this.handleDimensions.bind(this);

        // Refs
        this.wrapper = null;

        // Initial state
        this.state = {
            isLongImage: false,
            isScrollable: false,
            hasBeenScrolled: false
        };
    }

    componentDidMount() {
        this.throttledUpdateScrollStatus();
    }

    updateScrollStatus() {
        if (!this.wrapper) { return; }
        this.setState((prevState) => {
            if (!prevState.hasBeenScrolled) {
                return {
                    isScrollable: this.wrapper.scrollHeight > this.wrapper.offsetHeight,
                    hasBeenScrolled: this.wrapper.scrollTop > 5
                };
            }
        });
    }

    handleDimensions({ width, height }) {
        const longAspectRatio = 1 / 1.5; // We consider an image with an aspect ration of 1:1.5 or taller a "Long image";
        const imageAspectRatio = width/height;
        if (imageAspectRatio <= longAspectRatio) {
            this.setState({ isLongImage: true }, this.throttledUpdateScrollStatus);
        }
    }

    render() {
        const { filerr, previewMessage, context } = this.props,
            { isLongImage } = this.state,
            { onError } = context,
            figureClasses = classNames('thumbnail', { 'long-image': isLongImage });

        const { fileName, previewUrls } = filerr;
        const thumbnail = (
            <figure className={figureClasses}
                tabIndex="0"
                ref={(node) => this.wrapper = node}
                onScroll={this.throttledUpdateScrollStatus}>
                <Img alt={fileName}
                    isActive={true}
                    src={previewUrls && previewUrls.collaboration}
                    onDimensions={this.handleDimensions}
                    onError={onError}/>
            </figure>
        );

        if (!previewUrls || !previewUrls.collaboration) {
            onError();
        }

        return (
            <div className="preview-container">
                { previewMessage && <div className="message-box">{ previewMessage }</div> }
                <div className="preview preview-image">
                    {thumbnail}
                </div>
            </div>
        );
    }
}

Image.propTypes = {
    filerr: FilerrShape.isRequired,
    previewMessage: PropTypes.string,
    context: contextPropType
};

const mapContextToProps = (context) => ({
    context
});

export default withContext(Context, mapContextToProps, Image);
